import AdminMenu from '@/features/admin-menu/AdminMenu';
import { ReactNode, createContext, useState } from 'react';

export interface AdminMenuType {
  openAdminMenu: () => void;
  closeAdminMenuDrawer: () => void;
}

const initialState = {
  openAdminMenu: () => undefined,
  isAdminMenuOpen: true,
  closeAdminMenuDrawer: () => undefined,
};

export const AdminMenuContext = createContext<AdminMenuType>(initialState);

const AdminMenuProvider = ({ children }: { children: ReactNode }) => {
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);

  const openAdminMenu = () => {
    setIsAdminMenuOpen(true);
  };
  const closeAdminMenuDrawer = () => {
    setIsAdminMenuOpen(false);
  };

  return (
    <AdminMenuContext.Provider
      value={{
        openAdminMenu,
        closeAdminMenuDrawer,
      }}
    >
      {children}
      <AdminMenu isOpen={isAdminMenuOpen} onClose={closeAdminMenuDrawer} />
    </AdminMenuContext.Provider>
  );
};

export default AdminMenuProvider;
